import { styled } from "@mui/material/styles";
export const LogoItem = styled("div")(
  ({ isPointer }: { isPointer: boolean }) => ({
    cursor: isPointer ? "pointer" : undefined,
  }),
);
